import { render, staticRenderFns } from "./dynamic-component.vue?vue&type=template&id=3ff99b55"
import script from "./dynamic-component.vue?vue&type=script&lang=js"
export * from "./dynamic-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports